package com.tixforgigs.common.core.util

import com.tixforgigs.apax.config.models.Flavor
import com.tixforgigs.common.core.enums.ClientType
import com.tixforgigs.common.core.extensions.orElse
import com.tixforgigs.common.core.extensions.tryCatchSentry
import com.tixforgigs.common.http.HttpClient.CLIENT_TYPE
import kotlinx.browser.document
import kotlinx.browser.window
import kotlin.uuid.Uuid

object IdHelper {

  fun generateRandomId(
    length: Int = 10,
    numbersAllowed: Boolean = true,
  ): String {
    val allowedChars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
      .plus(if (numbersAllowed) "123456789" else "")
    return (1..length)
      .map { allowedChars.random() }
      .joinToString("")
  }

  val templateId: Uuid
    get() = when (CLIENT_TYPE) {
      ClientType.TEMPLATE_CONFIGURATOR -> Uuid.NIL
      ClientType.ARAI_STOREFRONT -> {
        tryCatchSentry {
          val templateIdInDataAttribute = document.documentElement?.getAttribute("data-id")
          templateIdInDataAttribute?.lowercase()?.let { Uuid.parse(it) }
            .orElse { throw IllegalStateException("Template ID not found: $templateIdInDataAttribute on ${window.location.href}") }
        }.getOrElse { Uuid.NIL }
      }
    }

  fun redirectUppercaseTemplateIdToLowercase(): Boolean {
    val segments = window.location.pathname.split("/")
    val templateIdIndex = segments.indexOf("store").takeIf { it >= 0 }?.plus(1).orElse { return false }
    val templateIdInPath = segments.getOrNull(templateIdIndex).orElse { return false }
    val canonicalTemplateId = templateId.toString()

    if (!templateIdInPath.equals(canonicalTemplateId, ignoreCase = true) || templateIdInPath == canonicalTemplateId) {
      return false
    }

    window.location.replace(
      segments.toMutableList().also { it[templateIdIndex] = canonicalTemplateId }.joinToString("/")
        .plus(window.location.search)
        .plus(window.location.hash)
    )
    return true
  }

  val flavor: Flavor
    get() = tryCatchSentry {
      val flavorInDataAttribute = document.documentElement?.getAttribute("data-flavor")
      flavorInDataAttribute?.let { plainFlavor -> Flavor.entries.first { it.value == plainFlavor } }
        .orElse { throw IllegalStateException("Flavor not found in Enum (${Flavor::class}): $flavorInDataAttribute") }
    }.getOrElse { Flavor.PROD }

  val apiClientId: String
    get() = tryCatchSentry {
      val idInDataAttribute = document.documentElement?.getAttribute("data-api-client-id")
      idInDataAttribute.orElse { throw IllegalStateException("API client ID not found: $idInDataAttribute") }
    }.getOrElse {
      ToastUtil.showErrorToast("API client ID not found!")
      String()
    }

  val authClientId: String
    get() = tryCatchSentry {
      val idInDataAttribute = document.documentElement?.getAttribute("data-auth-client-id")
      idInDataAttribute.orElse { throw IllegalStateException("AUTH client ID not found: $idInDataAttribute") }
    }.getOrElse {
      ToastUtil.showErrorToast("AUTH client ID not found!")
      String()
    }

  val isEmbedded: Boolean
    get() = document.documentElement?.getAttribute("data-embed")?.toBoolean() ?: false

  val origin: String?
    get() = document.documentElement?.getAttribute("data-origin")
}
